import { DynamicFieldInstruction, applyOptionsDynamicDirectives, optionsInputDefaults, optionsInputMap } from './shared';
export class InputDropdownInstruction extends DynamicFieldInstruction {
  getDefaults() {
    return {
      ...optionsInputDefaults,
      showClear: true
      // dropdownPlaceholder:undefined, // NOTE: Must not be set explicitly as it would always overwrite placeholder input with undefined!
    };
  }
  constructor(config) {
    super();
    /** object map of input name -> source name / function */
    this.inputMap = {
      ...optionsInputMap,
      showClear: 'showClear',
      placeholder: 'dropdownPlaceholder'
    };
    this.attributeMap = {};
    this.setConfig(config);
    this.addDirectivesPlugin(applyOptionsDynamicDirectives);
  }
  load() {
    return import(/* webpackChunkName: "ui-input-dropdown" */
    /* webpackMode: "lazy" */
    '@common/ui/frontend-shared/input-dropdown').then(m => m.UiInputDropdownComponent);
  }
}